<script>
  import Header from "lib/components/Header.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import ButtonNew from "lib/components/ButtonNew.svelte";
  import TechnologyRecommendation from "./components/technologyRecommendation.svelte";
  import ButtonIcon from "lib/components/buttonIconOnly.svelte";
  import { pmfilters } from "lib/stores.js";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";
  import Filter from "./components/filter/Filter.svelte";
  import FilterToast from "./components/FilterToast.svelte";
  let showToast = false;

  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Pagination,
    DataTableSkeleton,
  } from "carbon-components-svelte";

  import PaxbotSidemenu from "lib/components/paxbot/paxbotSidemenu.svelte";
  import PaxbotBottomRight from "lib/components/paxbot/paxbotBottomRight.svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import RatingPoint from "./components/RatingPoint.svelte";
  import PotentialDetails from "./PotentialDetails.svelte";
  import AutomationAnalyzerSideMenu from "./components/AutomationAnalyzerSideMenu.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  const { setCurrentView } = filtersConfigStore;

  export let analysisid;

  /// temp data

  let costPerHour = 75;
  let detailView = false;
  let view = 0;

  let rows = [];
  let selectedClusters = [];

  let filteredRowIds = [];
  let allRows = [];
  let initialRowsSet = false;
  let defaultSort = { key: "std_score", direction: "descending" };
  let loading = true;

  $: setCurrentView("Automation analyzer");

  $: {
    if ($pmfilters && $filtersConfigStore.storeLoaded) automationTraces();
  }

  let headers = [
    { key: "name", value: "Process" },
    { key: "std_score", value: "Std Store" },
    { key: "totaltime", value: "Time" },
    { key: "ncases", value: "Count" },
    { key: "applications", value: "Applications" },
    // { key: "unique_app_count", value: "Suggestion" },
    { key: "details", value: "Details" },
  ];

  let selectedRowIds = [];
  let selectedRow;
  let selectedRows = [];
  //// Unwanted Apps

  // @Adrian @Jonas haben wir einen Endpunkt, in dem die unwanted apps deklariert sind?
  let unwantedApps = [];

  fetchWithSession(`/api/damprojects/getAppnameMapping`)
    .then((res) => res.json())
    .then((data) => {
      unwantedApps = data
        .filter((mapping) => mapping.apptype === "unwanted")
        .map((mapping) => mapping.clearname);
    });

  //// Office Apps

  let officeApps = [
    "Word",
    "Excel",
    "PowerPoint",
    "Outlook",
    "Access",
    "OneNote",
    "Publisher",
    "Visio",
    "Project",
    "Teams",
  ];

  let pageSize = 10;
  let page = 1;

  let paxbotOpen = false;
  let firstLoad = true;
  const paxbotTime = getTop10TotalTimeInHours(rows);

  $: {
    if (!initialRowsSet && rows.length > 0) {
      allRows = [...rows];
      initialRowsSet = true;
    }
  }

  $: if (firstLoad && rows.length > 0) {
    selectedRowIds = rows.map((row) => row.id);
    firstLoad = false;
  }
  /// KPIs
  $: {
    if (selectedRowIds.length > 0) {
      selectedRowIds = selectedRowIds.map((id) => String(id));
    }
  }

  $: {
    if (selectedRowIds.length === 0) {
      selectedRows = [];
    }
  }

  $: {
    if (view) {
      updateView();
    }
  }

  function updateView() {
    if (view === 1) {
      if (!selectedRow || selectedRowIds.length === 0) {
        selectedRow = rows[0];
        selectedRowIds = [selectedRow.id];
      }
      detailView = true;
    } else if (view === 0) {
      if (rows.length === 0) {
        automationTraces();
      }
      if (selectedRowIds.length > 0) {
        selectedRows = selectedRowIds.map((id) =>
          allRows.find((row) => row.id === String(id)),
        );
      }
      detailView = false;
    }
  }

  function automationTraces() {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    loading = true;
    fetchWithSession(
      `/api/analysis/automation/automationTraces/${analysisid}?filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        rows = data;
        if (selectedClusters.length == 0 && rows.length > 0)
          selectedClusters = [rows[0].id];
        if (data.length == 0) showToast = true;
        loading = false;
      });
  }

  function togglePaxbot() {
    paxbotOpen = !paxbotOpen;
  }

  function getTop10TotalTimeInHours(rows) {
    // Sort the rows by total_time in descending order
    const sortedRows = rows.sort((a, b) => b.total_time - a.total_time);

    // Select the top 10 entries
    const top10Rows = sortedRows.slice(0, 10);

    // Calculate the sum of total_time of the top 10 entries
    const totalSumSeconds = top10Rows.reduce(
      (sum, row) => sum + row.total_time,
      0,
    );

    // Convert seconds to hours and round to one decimal place
    const totalSumHours = (totalSumSeconds / 3600).toFixed(0);

    return totalSumHours;
  }

  function openDetails(row) {
    selectedRow = row;
    selectedRowIds = [selectedRow.id];
    view = 1;
    detailView = true;
  }
</script>

<FilterToast bind:showToast></FilterToast>

<Header
  section="Automation Analyzer"
  breadcrumb={detailView ? "Details" : "Overview"}
>
  <!-- @Adrian @Jonas vom Bauchgefühl sinniger übers BE. Bitte selektierte IDs mit
  den IDs des DF abgleichen, entsprechend cutten und je nach Button im gewählten
  Format ausgeben -->
  {#if detailView}
    <!-- <Button
      text="Go Back to Overview"
      on:click={() => {
        detailView = false;
        view = 0;
      }}
      iconLeft={true}
      icon="arrow_left"
      variant="secondary"
    /> -->
  {:else}
    <ButtonNew
      setting={true}
      text="Automation Candidates"
      secondary={true}
      icon="download"
      iconLeft={true}
      disabled={true}
    />
    <ButtonNew
      setting={true}
      text="BPMN"
      secondary={true}
      icon="download"
      iconLeft={true}
      disabled={true}
    />
  {/if}
  <Filter />
</Header>

{#if detailView}
  <PotentialDetails
    {analysisid}
    processData={allRows}
    bind:selectedRowIds
    bind:selectedRows
    selectedProcess={[String(selectedRow.id)]}
    bind:detailView
    bind:view
  />
{:else}
  <SectionWrapper>
    <main slot="main">
      {#if loading}
        <DataTableSkeleton
          rows={15}
          {headers}
          showToolbar={true}
          showHeader={false}
        />
      {:else}
        <DataTable
          batchSelection
          sortable
          {pageSize}
          {page}
          {headers}
          {rows}
          bind:selectedRowIds
          sortKey={defaultSort.key}
          sortDirection={defaultSort.direction}
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch
                persistent
                value=""
                shouldFilterRows={(row, value) => {
                  return (
                    row.name.toLowerCase().includes(value.toLowerCase()) ||
                    row.applications.some((app) =>
                      app.toLowerCase().includes(value.toLowerCase()),
                    )
                  );
                }}
                bind:filteredRowIds
              />
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:cell let:row>
            {#if cell.key === "unique_app_count" && cell.value === 1}
              <!-- {#if row.applications.some((app) => officeApps.includes(app))}
              <div class="techRecomm">
                <TechnologyRecommendation text="Power Automate" />
              </div>
            {:else}
              <div class="techRecomm">
                <TechnologyRecommendation text="Z-Code" />
              </div>
            {/if} -->
            {:else if cell.key === "unique_app_count" && cell.value > 1}
              <!-- <div class="techRecomm">
              <TechnologyRecommendation text="RPA" />
              <TechnologyRecommendation text="IPA" />
            </div> -->
            {:else if cell.key === "applications"}
              <div class="techRecomm">
                {#key unwantedApps}
                  {#each Array.from(new Set(cell.value)) as app}
                    <TechnologyRecommendation
                      text={app}
                      color={unwantedApps.includes(app) ? "#ff5f1f" : "#f2f2f2"}
                      textColor="#1c1c20"
                    />
                  {/each}
                {/key}
              </div>
            {:else if cell.key === "totaltime"}
              {formatTimeDelta(cell.value)}
            {:else if cell.key === "std_score"}
              <div class="rating_wrapper">
                <RatingPoint filled={row.std_score > 0} />
                <RatingPoint filled={row.std_score > 20} />
                <RatingPoint filled={row.std_score > 40} />
                <RatingPoint filled={row.std_score > 60} />
                <RatingPoint filled={row.std_score > 85} />
              </div>
            {:else if cell.key === "details"}
              <ButtonIcon icon="info" on:click={openDetails(row)} small />
              <!-- <div class="details">
            <img src="/img/assistant/icons/info.svg" alt="" on:click={()=>detailView = true}/>
          </div> -->
            {:else}
              {cell.value}
            {/if}
          </svelte:fragment>
        </DataTable>
        <Pagination
          bind:pageSize
          bind:page
          totalItems={filteredRowIds.length}
          pageSizes={[15, 25, 50]}
        />
      {/if}
    </main>
    <div slot="menu" class="menu">
      <ContentSwitcher options={["Table", "Flowchart"]} bind:selected={view} />
      <PaxbotSidemenu bind:paxbotOpen text={"Coming soon!"}>
        {#if paxbotOpen !== true}
          <ButtonNew
            text="Start"
            color="white"
            setting={true}
            disabled={true}
            on:click={togglePaxbot}
          />
        {:else}
          <ButtonNew
            text="Close"
            color="white"
            setting={true}
            on:click={togglePaxbot}
          />
        {/if}
      </PaxbotSidemenu>
      <AutomationAnalyzerSideMenu
        bind:selectedRowIds
        {selectedRows}
        bind:rows
        {detailView}
        {loading}
      />
      <!-- <Accordion heading="Information" open={true}>
        <div class="kpi_wrapper">
          <SideKPI
            name="Total Time"
            showIcon={true}
            icon="time_dark"
            value={convertedTime}
          />
          <SideKPI
            name="Total Count"
            showIcon={true}
            icon="hash"
            value={totalCount}
          />
          <SideKPI
            name="Potential Savings"
            showIcon={true}
            icon="cash"
            value={totalCost}
            unit="$"
          />
        </div>
      </Accordion> -->
      <!-- @Adrian @Jonas machen wir im nächsten Step -->
      <!-- <Accordion heading="Process Selection">asdf</Accordion> -->
      <!-- @Adrian @Jonas machen wir im nächsten Step -->
      <!-- <Accordion heading="App Selection">asdf</Accordion> -->
      <!-- <Accordion heading="Calculation">
        <div class="kpi_wrapper">
          <TextInput
            labelText="Cost / hour"
            placeholder={costPerHour}
            bind:value={costPerHour}
          />
          <TextInput
            labelText="Recording Time"
            placeholder={timeInWeeks}
            bind:value={timeInWeeks}
          />
          <TextInput
            labelText="Used Sensors"
            placeholder={totalSensors}
            bind:value={totalSensors}
          />
          <TextInput
            labelText="Total Employees"
            placeholder={totalWorkers}
            bind:value={totalWorkers}
          />
        </div>
      </Accordion> -->
    </div>
  </SectionWrapper>
{/if}
<!-- @Adrian @Jonas vom Bauchgefühl im BE schneller umsetzbar: Bitte Endpunkt, der den 
  ngrams-DF nach Count * Median-Time (=Cost) sortiert und head 10 als eigenen DF 
  definiert und ausgibt. Von diesem DF brauche ich dann noch den summierten 
  Zeitbedarf (soll in Platzhalter TIME, vorher über convertTime - Funktion) sowie die Kosten 
  (=TIME / 3600 * Variable "costPerHour"). -->
<PaxbotBottomRight heading="AI-Assistant (Paxbot)" bind:paxbotOpen>
  <div class="text">
    I selected the <span class="bold">10</span> most profitable candidates for
    automation. If you implement all of them, you can save up to
    <span class="bold">{paxbotTime} hours</span>
    or <span class="bold">{(paxbotTime * costPerHour).toLocaleString()} $</span>
    per year.
  </div>
  <div class="button_wrapper">
    <!-- @Adrian @Jonas bitte den vorher definierten DF hier als .csv oder .xlsx 
      ausgeben und je nach wahl in die beiden Buttons einpflegen -->
    <ButtonNew
      setting={true}
      text="Download (.csv)"
      color="white"
      icon="download_dark"
      iconLeft={true}
    />
    <ButtonNew
      setting={true}
      text="Download (.xlsx)"
      color="white"
      icon="download_dark"
      iconLeft={true}
    />
  </div>
</PaxbotBottomRight>

<style>
  .menu {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  main {
    width: 100%;
  }

  .techRecomm {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    overflow: hidden;
    padding: 0.5rem 0;
  }

  .text {
    line-height: 1.2rem;
  }

  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    padding-top: 1.6rem;
  }

  .rating_wrapper {
    display: flex;
    gap: 0.2rem;
  }
</style>
